/**
 * Jobi Joba easter eggs
 */

let invasionStarted = false;
let characterCount = 0;
let specialSpawned = false;
let specialKilled = false;
let characters = [];

function spawnCharacter() {

    if (specialKilled) return;

    let character = document.createElement("img");
    character.src = "/images/mascotte/jobi-1.png";
    character.style.position = "fixed";
    character.style.width = "92px";
    character.style.height = "73px";
    character.style.left = Math.random() * window.innerWidth + "px";
    character.style.top = Math.random() * window.innerHeight + "px";
    character.style.transition = "all 2s";

    characterCount++;

    if (characterCount > 10 && Math.random() < 0.1 && !specialSpawned) {
        character.src = "/images/mascotte/jobi-1.png";
        character.style.width = "100px"; // Un peu plus petit
        character.style.height = "80px"; // Un peu plus petit
        character.style.filter = "brightness(150%)"; // Un peu plus brillant

        let clickCount = 0;
        character.addEventListener("click", function() {
            clickCount++;
            // Réduisez la taille de 20%
            let currentWidth = parseFloat(character.style.width);
            let currentHeight = parseFloat(character.style.height);
            character.style.width = (currentWidth * 0.7) + "px";
            character.style.height = (currentHeight * 0.7) + "px";
            if (clickCount === 3) {
                // Supprimez tous les personnages
                characters.forEach(char => char.remove());
                specialKilled = true;
                location.reload();
            }
        });

        specialSpawned = true;
    }

    document.body.appendChild(character);
    characters.push(character); // Ajoutez le personnage à la liste des personnages

    // Faites bouger le personnage
    setInterval(() => {
        character.style.left = Math.random() * window.innerWidth + "px";
        character.style.top = Math.random() * window.innerHeight + "px";
    }, 2000); // Le personnage se déplace toutes les 2 secondes

    if (characters.length < 150) {
        // Spawn un autre personnage après 1 à 3 secondes
        setTimeout(spawnCharacter, Math.random() * 2000 + 1000);
    }
}

let timer;
let clickCounter = 0;

const logo = document.getElementById('logo');
const loader = document.getElementById('logoLoader');
const link = document.getElementById('logoLink');
const navTop = document.getElementById('navigationTop');

logo.addEventListener('mouseenter', function() {
    timer = setTimeout(function() {
        loader.classList.remove('hidden');
        link.href = "javascript:void(0);"; // disable link
    }, 3000);
});

logo.addEventListener('mouseleave', function() {
    clearTimeout(timer);
});

loader.addEventListener('click', function() {
    clickCounter++;
    if (clickCounter === 1) {
        setTimeout(function() {
            if (clickCounter >= 3) {

                navTop.style.height = "40rem";
                navTop.style.backgroundColor = 'rgb(60, 64, 70)';
                navTop.innerHTML = '<canvas id="canvas3d"></canvas>';

                executeSplineScript();
            }
            clickCounter = 0;
        }, 1000);
    }
});

let sequence = [];

let pressedKeys = [];

window.addEventListener('keydown', (event) => {
    pressedKeys.push(event.key.toLowerCase());

    if (pressedKeys.length > 4) {
        pressedKeys.shift();
    }

    if (pressedKeys.join('') === 'jobi') {
        console.log(sequence);
    }
});

let audioStarted = false;

function executeSplineScript() {
    import('@splinetool/runtime').then((module) => {
        const Application = module.Application;
        const canvas = document.getElementById('canvas3d');
        const spline = new Application(canvas);

        spline
            .load('https://prod.spline.design/mZdfHTdFHw2dOB32/scene.splinecode')
            .then(() => {

                let events = [
                    'b6a9d96e-9ae0-4f0d-8182-00234a58430b',
                    '8d09c1c0-ed0b-456d-ba4b-3a30cf4f74b5',
                    '317cbc6d-eb1d-4d9f-9d70-acfde74c3c11',
                    '2af4f9d8-0451-48c9-b619-d1eae02799d3',
                    '7f050a9b-3e59-49d9-92a7-97ab2b3a1267',
                    'bf0f6fdf-611e-45ec-b45f-c9a9f51b9ebe',
                    'c36f0249-4e2c-4a0a-8e48-09642e82e779',
                    'a9c3c32b-c153-4d69-968f-c8e9e78c12f4',
                    '78402396-59ee-4d38-8522-c5ec7fd0d594',
                    '3a8cf9ff-db44-47df-aa4c-d5353a7f1477',
                    'a60effa1-b992-41f1-bb58-066d777bee27',
                    '7e06db30-3423-4f94-8627-410177560fa9'
                ];

                let keys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];
                let sequenceLength = 12;

                for(let i = 0; i < sequenceLength; i++){
                    sequence.push(keys[Math.floor(Math.random()*keys.length)]);
                }

                let sequenceIndex = 0;

                window.addEventListener('keydown', function(event) {
                    if (event.key === sequence[sequenceIndex]) {
                        if (sequenceIndex < sequence.length - 1) {
                            spline.emitEvent('keyUp',events[sequenceIndex]);
                            sequenceIndex++;
                        }
                        else {


                            spline.emitEvent('keyUp', '56e57f92-efc1-48d0-a9d7-c5f79e2a7668');
                            spline.emitEvent('keyUp', '30c8bc6c-9a0b-4207-bbd6-ac767211e6c8');
                            spline.emitEvent('keyUp', '1ce98688-ed53-4689-9389-7a88b93f44dc');
                            spline.emitEvent('keyUp', 'c38cf675-84fd-4f82-b323-d74efe5f6133');
                            spline.emitEvent('keyUp', '6521022b-253b-4610-8c8b-9bfdd450da87');

                            setInterval(() => {
                                navTop.style.backgroundColor = "white";
                                navTop.style.height = "";
                                navTop.innerHTML = "";
                                disableAllElements();
                                invasionStarted = true;
                                spawnCharacter();

                                if(!audioStarted) {
                                    let audio = new Audio('/images/mascotte/jobi-joba.mp3');
                                    audio.loop = true;
                                    audio.play();
                                    audioStarted = true;
                                }

                            },3000);

                            sequenceIndex = 0;
                        }
                    } else {
                        sequenceIndex = 0;
                    }
                });

            });

    });
}

let interactiveElements = document.querySelectorAll('button, input, select, textarea, a');

function disableAllElements() {

    interactiveElements.forEach(element => {
        if (element.tagName === 'A') {
            element.style.pointerEvents = 'none';
        } else {
            element.disabled = true;
        }
    });
}

function enableAllElements() {
    interactiveElements.forEach(element => {
        if (element.tagName === 'A') {
            element.style.pointerEvents = '';
        } else {
            element.disabled = false;
        }
    });
}
